import { MOSCOW_AND_REGION_ID, SPB_AND_REGION_ID } from 'shared/constants/regions';
import { TLocation } from 'shared/types/location';

export const getRegionId = (location: TLocation, withRegionExtension = true): number => {
  if (location === 'moscow_mo') {
    return MOSCOW_AND_REGION_ID;
  }

  if (location === 'spb_lo') {
    return SPB_AND_REGION_ID;
  }

  if (withRegionExtension && location.parentId) {
    return location.parentId;
  }

  return location.id;
};
